import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationStats = ({ notifications }) => {
  const getStatsByType = () => {
    const stats = {
      quote: { count: 0, unread: 0 },
      milestone: { count: 0, unread: 0 },
      message: { count: 0, unread: 0 },
      vendor: { count: 0, unread: 0 }
    };

    notifications?.forEach(notification => {
      if (stats?.[notification?.type]) {
        stats[notification?.type].count++;
        if (!notification?.isRead) {
          stats[notification?.type].unread++;
        }
      }
    });

    return stats;
  };

  const stats = getStatsByType();
  const totalUnread = notifications?.filter(n => !n?.isRead)?.length || 0;

  const statCards = [
    {
      type: 'quote',
      label: 'Quotes',
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      count: stats?.quote?.count,
      unread: stats?.quote?.unread
    },
    {
      type: 'milestone',
      label: 'Milestones',
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      count: stats?.milestone?.count,
      unread: stats?.milestone?.unread
    },
    {
      type: 'message',
      label: 'Messages',
      icon: 'MessageCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      count: stats?.message?.count,
      unread: stats?.message?.unread
    },
    {
      type: 'vendor',
      label: 'Vendors',
      icon: 'Users',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-200',
      count: stats?.vendor?.count,
      unread: stats?.vendor?.unread
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map(card => (
        <div
          key={card?.type}
          className={`bg-card border ${card?.borderColor} rounded-lg p-4 hover:shadow-card transition-shadow duration-200`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 ${card?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.color} />
            </div>
            {card?.unread > 0 && (
              <span className="px-2 py-1 bg-primary text-white text-xs font-semibold rounded-full">
                {card?.unread}
              </span>
            )}
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground mb-1">{card?.count}</p>
            <p className="text-sm text-text-secondary">{card?.label}</p>
            {card?.unread > 0 && (
              <p className="text-xs text-primary mt-1">
                {card?.unread} unread
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationStats;